
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const h47Tube: IProductData = {
  id: "heiserman-h47-tube",
  name: "Heiserman Audio H47 Tube",
  description: "Tribute to the legendary U47 - includes a Pelican case, shock mount, power supply, and cables",
  specialOrder: true,
  images: ["/img/heisermanaudio_H47Tube.png", "/img/heisermanaudio_H47Tube_internal.jpg", "/img/heisermanaudio_H47Tube_all.png"],
  details: [{
    label: "Description",
    markdown: `
Possibly the most famous mic in the world, the Neumann U47 is worthy of its endless accolades.  
With its richly detailed, perfectly balanced tone, the U47 has earned its place as the king of microphones.  
The Heiserman H47tube is our tribute to the king.  

Extensive side-by-side comparisons with a highly sought after vintage U47 allowed us to fine tune and dial in the exact components needed to perfectly match the tone.  
The H47tube sounds so close to the vintage mic that Grammy winning engineers have struggled to tell the two apart.  

TRUE TO THE ORIGINAL:  
The Heiserman team of unabashed tone snobs, and when a mic sounds this good, it has to look the part too.  
From the integrated polar pattern switch to the exact dimensions of the headbasket mesh, this premium handmade mic stands toe-to-toe with any mic that claims the U47 heritage.  

Whether you're an experienced pro or new to the U47, you'll appreciate the attention to detail and the premium touches that make the H47tube look and feel as good as it sounds.   
From top to bottom, it doesn't get any better than this!  

THE CAPSULE. 
The original Neumann U47 was produced over a period of 16 years, during which time there were two different capsules, the K47 and the M7. The Heiserman H47tube is available here with the HK47 capsule.  
For most people, the HK47 capsule will be the best choice because it provides the most balanced tone, and is equally well suited for vintage and modern productions alike.  

THE CIRCUIT. 
Heiserman tested countless transformers, tubes, capacitors, and resistors before settling on the final design of the H47tube.  
Each of these hand-selected components contributes to the beautiful tone of the H47tube, No expense was spared, ensuring the absolute best performance and sound.  
`
  }, {
    label: "Features",
    markdown: `
- Highly detailed recreation of the 251 large diaphragm tube condenser microphone
- Generation 4 Hk12 capsule with the same brass and acrylic chambered backplates and rich 6µm gold sputtered DuPont Mylar
- T14/1 transformer engineered from a pristine vintage unit from 1961
- Vishay and Takman Rex resistors, NOS polystyrene and PIO capacitors
- Custom bulletproof power supply with world switching, a 7.5 meter Sommer tube mic cable with custom 251 style connector and a rugged flight case included
    `
  }, {
    label: "Specifications",
    markdown: `
- LENGTH | 216mm
- DIAMETER | 50mm
- POLAR PATTERN | Cardioid, Omni, Figure-8
- Capsule | Generation 4 Hk12 Brass and Acrylic Chambered
- Tube | 6072 TAD Highgrade
- Transformer | T14/1
- Sensitivity | 17mV/Pa ± 1dB
- THD @ 1Khz @ 1Pa | <0.3%
- IMPEDANCE | 200 ohms / 50 Ohms (switchable via jumper links)
- FREQUENCY RANGE | 20 Hz - 20 kHz
- MAX. SPL | 130 dB
- Self Noise | 10dBA
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://heisermanaudio.com/products/h251-microphone-reservation-list" target="_blank">https://heisermanaudio.com/products/h251-microphone-reservation-list</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.MICROPHONE],
    manufacturer: BRAND.HEISERMAN,
  }
}